<template>
  <div>
    <b-row align-v="center" class="mb-1">
      <b-col>
        <span class="font-weight-bold">Set Variable</span>
      </b-col>
      <b-col class="text-right">
        <b-button variant="add" @click="onAddVariable">
          <font-awesome-icon class="" size="sm" icon="plus" />
        </b-button>
      </b-col>
    </b-row>
    <div v-if="form.mainIntentVariable.length" class="custom-div px-2 py-1">
      <b-row v-for="(item, index) in form.mainIntentVariable" v-bind:key="index">
        <b-col>
          <InputSelectValueObj
            title="Variable"
            name="mainIntentVariable.variableId"
            isRequired
            :options="variableList"
            valueField="item"
            textField="name"
            v-model="item.Variable"
            @onDataChange="(val) => onDataChangeVariable(val, item)"
            :isValidate="
              v.form.mainIntentVariable.$each.$iter[index].variableId.$error
            "
            :v="v.form.mainIntentVariable.$each.$iter[index].variableId"
          />
        </b-col>
        <b-col>
          <InputText
            textFloat="Value"
            placeholder="Value"
            type="text"
            name="mainIntentVariable.data"
            v-model="item.data"
            isRequired
            :isValidate="v.form.mainIntentVariable.$each.$iter[index].data.$error"
            :v="v.form.mainIntentVariable.$each.$iter[index].data"
            :detail="`Type: ${item.Variable.type}`"
          />
        </b-col>
        <b-col cols="1 px-0 pt-2">
          <font-awesome-icon
            @click="handleDeleteVariable(item.id, index)"
            icon="trash-alt"
            class="pointer text-danger mt-4"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InputText from "@/components/inputs/InputText";
import InputSelectValueObj from "@/components/inputs/InputSelectValueObj";
export default {
  components: {
    InputText,
    InputSelectValueObj,
  },
  props: {
    form: {
      required: true,
      type: Object,
    },
    v: {
      required: true,
      type: Object,
    },
    languageActiveId: {
      required: false,
      type: Number,
    },
  },
  computed: {
    ...mapGetters({ variableList: "flowBuilder/getVariableList" }),
  },
  methods: {
    onAddVariable() {
      this.form.mainIntentVariable.push({
        id: 0,
        variableId: 0,
        data: "",
        Variable: this.variableList[0],
      });
    },
    onDataChangeVariable(val, item) {
      item.variableId = val.id;
      item.Variable = val;
    },
    handleDeleteVariable(id, index) {
      this.form.mainIntentVariable.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-add {
  margin: 0.175rem;
  padding: 0.25rem 0.75rem 0.25rem 0.75rem;
  background-color: #b41bb4;
  border-color: #b41bb4;
  color: white;
  border-radius: 6px !important;
}
::v-deep .custom-div  {
  border: 1px solid #bcbcbc;
  max-height: 250px;
  overflow-x: hidden;
  border-radius: 6px;
  margin-bottom: 8px;
  .div-input {
    margin-bottom: 5px !important;
  }
}
</style>
